import React from "react";
import styled, { withTheme } from "styled-components";

const GoalRow = styled.div`
  margin-bottom: 20px;
  font-weight: 600;
  font-size: 14px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const GoalHeader = styled.div`
  display: inline-block;
  background: ${(props) => props.theme?.whiteSmoke};
  padding: 5px 16px;
  width: 100%;
`;

const GoalTitle = styled.div`
  float: left;
  color: ${(props) =>
    props.id === "calories" ? props.theme?.nero : props.theme?.geminiGray};
`;

const GoalOrigin = styled.div`
  float: right;
  color: ${(props) => props.theme?.nero || "#000000"};
`;

const GoalBody = styled.div`
  color: ${(props) => props.theme?.geminiGray};
  padding: 5px 16px;
  width: 100%;
  clear: both;
  margin-top: -6px;
  display: inline-block;
  position: relative;
`;

const OpacityBody = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: ${(props) => props.color || "#000000"};
  filter: alpha(opacity=10);
  /* IE */
  -moz-opacity: 0.1;
  /* Mozilla */
  opacity: 0.1;
  /* CSS3 */
`;

const GoalLabel = styled.div`
  float: left;
  color: ${(props) => props.color || "#000000"};
`;

const GoalValue = styled.div`
  float: right;
  color: ${(props) => props.theme?.nero};
`;

const TargetItem = (props) => {
  const { id, title, origin, color, label, value } = props;

  return (
    <GoalRow className="goal-item" data-testid={`target-item-${id}`}>
      <GoalHeader data-testid={`goal-header-${id}`}>
        <GoalTitle id={id} data-testid={`goal-title-${id}`}>
          {title}
        </GoalTitle>
        <GoalOrigin data-testid={`goal-origin-${id}`}>{origin}</GoalOrigin>
      </GoalHeader>
      <GoalBody data-testid={`goal-body-${id}`}>
        <OpacityBody {...{ color }} />
        <GoalLabel {...{ color }} data-testid={`goal-label-${id}`}>
          {label}
        </GoalLabel>
        <GoalValue data-testid={`goal-value-${id}`}>{value}</GoalValue>
      </GoalBody>
    </GoalRow>
  );
};

export default withTheme(TargetItem);
